var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","variant":"light","block":""},on:{"click":_vm.trigger}},[_c('i',{staticClass:"fa",class:_vm.marker ? 'fa-map-marked' : 'fa-map'})])}
var staticRenderFns = []

export { render, staticRenderFns }